// Run this example by adding <%%= javascript_pack_tag 'hello_erb' %> to the head of your layout file,
// like app/views/layouts/application.html.erb. Don't forget to uncomment erb tag after adding it to your layout file.
// __webpack_public_path__ = "<%= Rails.configuration.action_controller.asset_host %>"
import React from 'react';
import ReactDOM from 'react-dom';
// import Sentry from './Components/Ops/Sentry';
import Player from './Components/Player';

const InjectPlayer = () => {
  // Prevent duplicate injection if script is loaded twice (ScriptTag + app embed)
  if (document.getElementById('musica-player-react')) return;
  const node = document.createElement('div');
  node.id = 'musica-player-react';
  document.body.appendChild(node);
  ReactDOM.render(<Player />, node)
};

InjectPlayer();
